import { ExtrudeSolidT, ModelUtils } from "pytha";

/**
 * 结构梁
 */

export class SBeamT extends ExtrudeSolidT {
    type = 'SBeamT';
    materialUuid: string;
    sectionUuid: string;

    setMaterialUuid(materialUuid: string) {
        this.materialUuid = materialUuid;
    }

    setSectionUuid(sectionUuid: string) {
        this.sectionUuid = sectionUuid;
    }

    clone() {
        const entity = new SBeamT().copy(this);
        entity.uuid = ModelUtils.generateUUID();
        return entity;
    }

    toJson() {
        let parentJson = super.toJson();
        let data = {
            ...parentJson,
            type: this.type,
            materialUuid: this.materialUuid,
            sectionUuid: this.sectionUuid,
        }

        return data;
    }

    fromJson(json) {
        super.fromJson(json);
        return this;
    }



}